/*
 * Copyright (c) 2018 Well Solutions SRL. All Rights Reserved.
 * This software is the proprietary information of Well Solutions SRL.
 * Use is subject to license and non-disclosure terms
 */

export enum ErrorMessageEnum {
  missingEndTime = 'missingEndTime',
  missingStartTime = 'missingStartTime',
  invalidStartTime = 'invalidStartTime',
  invalidEndTime = 'invalidEndTime',
  startTimeAfterEndTime = 'startTimeAfterEndTime',
  startTimeNotStandard = 'startTimeNotStandard',
  endTimeNotStandard = 'endTimeNotStandard',
}
